// extracted by mini-css-extract-plugin
export default {"link":"HeadPage_link__AKQBb","lastLink":"HeadPage_lastLink__yAwce"};